var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',[_c('ul',{staticClass:"nav nav-pills"},[_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{
            name: 'create_subscription'
          }}},[_vm._v("\n          Create Subscription\n        ")])],1),_vm._v(" "),(_vm.subscriptionId)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{
            name: 'edit_subscription',
            params: {
              subscriptionId: this.subscriptionId
            }
          }}},[_vm._v("\n          Edit Subscription\n        ")])],1):_vm._e(),_vm._v(" "),(this.$root.isAdmin)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{
          name: 'import_subscriptions'
          }}},[_vm._v("\n          Import Subscriptions\n        ")])],1):_vm._e(),_vm._v(" "),(this.$root.isAdmin)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{
          name: 'export_subscriptions'
          }}},[_vm._v("\n          Export Subscriptions\n        ")])],1):_vm._e(),_vm._v(" "),(this.$root.isAdmin)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{
          name: 'subscription_stats'
          }}},[_vm._v("\n          Stats\n        ")])],1):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfab1970","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubscriptionNav.vue
// module id = 1269
// module chunks = 1